// 企业人才管理
import request from './request'

// 单个人才详情
export const getTalentDetail = (params) =>
    request({
        url: '/api/talent/detail',
        method: 'get', params
    })

// 收藏人才
export const favoriteTalent = (data) =>
    request({
        url: '/api/talent/favorite/?id='+data.id+'&isCollected='+data.isCollected,
        method: 'post', data
    })

// 人才列表
export const getTalentList = (params) =>
    request({
        url: '/api/talent/list',
        method: 'get', params,
        paramsSerializer: {
            indexes: null
        }
    })

    export const getInterviewResult = (params) =>
    request({
        url: '/api/talent/getInterviewResult',
        method: 'get', params
    })

    export const getInterviewResultList = (params) =>
    request({
        url: '/api/talent/list/' + params.interviewId,
        method: 'get', 
    })

// 获取面试分数
export const generateFeedback = (params) => {
    return request({
    url: '/api/talent/getInterviewScores',
    method: 'get',
    params
  })
}